module.exports = __webpack_public_path__ + "assets/img/hgc.2ab2aaf2.png";